<template>
  <div class="col-lg-6 animated fadeInRight">
    <div class="mail-box-header">
      <h2>Contas</h2>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome Completo</th>
            <th>Descrição</th>
            <th>Saldo</th>
            <th></th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(item, listIdx) in accounts.list" :key="listIdx">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.actualBalance | totalToCurrencyBR }}</td>
            <td class="list-command">
              <button
                class="btn btn-outline"
                @click="selectAccount(item, listIdx)"
              >
                <i class="fa fa-edit text-success"></i>
              </button>
            </td>
            <td class="list-command">
              <button
                class="btn btn-outline"
                @click="removeAccount(item, listIdx)"
              >
                <i class="fa fa-trash text-danger"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        fullName: '',
      },
      accounts: {
        originalList: [],
        list: [],
      },
    };
  },
  mounted() {
    this.listAccounts();
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },
  methods: {
    async listAccounts() {
      try {
        const accounts = await this.$store.dispatch(
          'FINANCIAL-ACCOUNT/ListAll',
        );

        this.accounts.list = accounts;
      } catch (error) {
        this.$toasted.error('Não foi possível listar as contas');
      }
    },
    selectAccount(item) {
      this.$emit('select-account', item);
    },
    removeAccount(item) {
      this.$emit('remove-account', item._id);
    },
  },
};
</script>